import { useField } from 'formik';
import { useEffect, useState } from 'react';

import { tableFormatPhoneNumber } from '../../utils/utils';
import {
  FieldErrorInfo,
  IInputField,
  Input,
  InputContainer,
  InputLabel,
  InputWrapper,
  LeftPlaceHolderCardIcon,
  RightPlaceHolderCardIcon,
} from './FormField';

export const NaijaPhoneInputField: React.FC<IInputField> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  // apiKey,
  ...props
}) => {
  const [field, meta, helper] = useField(props);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (!field.value) {
      setInputValue(field.value);
    }
  }, [field.value]);

  const handleChange = (e: any) => {
    const { value } = e.target;

    if (/^[\d-]*$/.test(value)) {
      const digitsOnly = value.replace(/\D/g, '');

      if (digitsOnly.length <= 11) {
        helper.setValue(value);
        setInputValue(tableFormatPhoneNumber(value));
      }
    } else if (value === '') {
      helper.setValue(value);
      setInputValue(value);
    }
  };

  return (
    <InputWrapper className={className}>
      <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
      <InputContainer>
        <Input
          {...field}
          {...props}
          value={inputValue}
          onChange={(e) => handleChange(e)}
        />
        {lpiSrc ? <LeftPlaceHolderCardIcon alt='icon' src={lpiSrc} /> : null}
        {rpiSrc ? <RightPlaceHolderCardIcon alt='icon' src={rpiSrc} /> : null}
      </InputContainer>
      {meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error.capitalize()}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export default NaijaPhoneInputField;
